<template>
  <div class="pr-2">
    <highcharts :options="chartOptions" ref="lineCharts"></highcharts>
    <v-divider></v-divider>
    <div>
      <template>
        <v-row justify="center">
          <v-col cols="2" class="pt-4">
            <v-select
              v-model="filters.type_value"
              :items="list_type"
              outlined
              label="Tipo"
              hide-details="auto"
              :item-text="customText"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col cols="2" class="pt-4" v-if="filters.type_value != 'year'">
            <v-select
              v-model="filters.year_value"
              :items="list_years"
              outlined
              label="Año"
              hide-details="auto"
            ></v-select>
          </v-col>
          <v-col
            cols="3"
            class="pt-4"
            v-if="filters.type_value == 'week' || filters.type_value == 'diary'"
          >
            <v-select
              v-model="filters.month_value"
              :items="list_months"
              item-value="id"
              outlined
              label="Mes"
              hide-details="auto"
            ></v-select>
          </v-col>
          <!-- <v-col cols="3" class="pt-4" v-if="filters.type_value == 'biannual'">
            <v-select
              v-model="filters.semestre_value"
              :items="list_semestre"
              outlined
              label="Semestre"
              :item-text="customText"
              item-value="id"
              hide-details="auto"
            ></v-select>
          </v-col>  -->
          <v-col cols="3" class="pt-4" v-if="filters.type_value == 'diary'">
            <v-select
              v-model="filters.week_value"
              :items="list_week"
              outlined
              label="Semana"
              :item-text="customText"
              item-value="id"
              hide-details="auto"
            ></v-select>
          </v-col>
          <!-- <v-col cols="3" class="pt-4" v-if="filters.type_value == 'diary'">
            <v-select
              v-model="filters.diary_value"
              :items="list_diary"
              outlined
              label="Dia"
              :item-text="customText"
              item-value="id"
              hide-details="auto"
            ></v-select>
          </v-col> -->
          <v-col cols="3" class="pt-4">
            <v-btn color="indigo" dark @click="handleUpdateChart">
              <v-icon size="14" class="mr-1">
                fas fa-redo-alt
              </v-icon>
              Actualizar
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";

import DashboardApi from "../../../apis/Dashboard";
import Tools from "../../../helpers/Tools";
import { generateColor } from "../../../helpers/GenerateColor/generateColor";

export default {
  name: "ProductsChart",
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      dataReport: [],
      categories: [],
      dataValues: [],
      list_years: [],
      list_type: [
        { id: "year", name: "Anual" },
        { id: "biannual", name: "Semestre" },
        { id: "month", name: "Mensual" },
        { id: "week", name: "Semanal" },
        { id: "diary", name: "Diarias" },
      ],
      list_semestre: [
        { id: "Semestre 1 - ", name: "Semestre 1" },
        { id: "Semestre 2 - ", name: "Semestre 2" },
      ],
      list_week: [
        { id: "1", name: "Semana 1" },
        { id: "2", name: "Semana 2" },
        { id: "3", name: "Semana 3" },
        { id: "4", name: "Semana 4" },
        { id: "5", name: "Semana 5" },
      ],
      list_diary: [
        { id: "Lunes", name: "Lunes" },
        { id: "Martes", name: "Martes" },
        { id: "Miercoles", name: "Miercoles" },
        { id: "Jueves", name: "Jueves" },
        { id: "Viernes", name: "Viernes" },
        { id: "Sabado", name: "Sabado" },
        { id: "Domingo", name: "Domingo" },
      ],
      list_months: [],
      filters: {
        year_value: this.$moment().year(),
        month_value: this.$moment().month() + 1,
        type_value: "year",
        semestre_value: "Semestre 1 - ",
        week_value: "1",
        diary_value: "Lunes",
      },
      chartOptions: {
        chart: {
          type: "column",
        },
        title: {
          text: "Ventas por mes",
        },
        xAxis: {
          categories: [],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: "Monto (S/)",
          },
        },
        tooltip: {
          pointFormat: "{series.name}: <b>S/ {point.y:.1f}</b>",
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        credits: {
          enabled: false,
        },
        series: [],
      },
    };
  },
  methods: {
    customText(item) {
      let text = item.name;

      return text;
    },
    getTotalSales() {
      DashboardApi.getTotalSales({
        year_value: this.filters.year_value,
        month_value: this.filters.month_value,
        type_value: this.filters.type_value,
        week_value: this.filters.week_value,
      })
        .then((response) => {
          this.dataReport = response.data;
          this.prepareData();
        })
        .catch((error) => {
          console.log("Ocurrió un error");
        });
    },
    prepareData() {
      let analisys = [];
      let values = [];

      if (this.filters.type_value == "year") {
        this.dataReport = this.dataReport.sort((a, b) => {
          const nameA = parseInt(a.name);
          const nameB = parseInt(b.name);

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      }

      this.dataReport.forEach((element, index) => {
        analisys.push(element.name);
        let itemValue = {
          color: generateColor(),
          y: parseFloat(element.value),
        };
        values.push(itemValue);
      });

      let valueSeries = [];
      valueSeries.push({
        name: "",
        data: values,
      });
      this.chartOptions.xAxis.categories = analisys;
      this.chartOptions.series = valueSeries;
    },
    getMonthName(number_month) {
      let names = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];

      return names[number_month - 1];
    },
    generateListYears() {
      this.list_years = [];
      let start_year = 2022;
      let end_year = this.$moment().year();
      for (let i = start_year; i <= end_year; i++) {
        this.list_years.push(i);
      }
    },
    handleUpdateChart() {
      let month_name = this.getMonthName(this.filters.month_value);
      this.handleChangeTitle();
      this.getTotalSales();
    },
    handleChangeTitle() {
      if (this.filters.type_value == "year") {
        this.chartOptions.title.text = "Total Ventas ";
      } else if (this.filters.type_value == "biannual") {
        this.chartOptions.title.text = `Total Ventas  del ${this.filters.semestre_value} ${this.filters.year_value} `;
      } else if (this.filters.type_value == "month") {
        this.chartOptions.title.text = `Total Ventas  del ${
          this.filters.year_value
        } - ${this.getMonthName(this.filters.month_value)}`;
      } else if (this.filters.type_value == "week") {
        this.chartOptions.title.text = `Total Ventas  del ${
          this.filters.year_value
        } - ${this.getMonthName(this.filters.month_value)}`;
      } else if (this.filters.type_value == "diary") {
        // this.chartOptions.title.text = `Total Ventas  - ${this.filters.diary_value}`;
        this.chartOptions.title.text = `Total Ventas - ${this.getMonthName(
          this.filters.month_value
        )} - ${
          this.list_week.find((dt) => dt.id == this.filters.week_value)?.name
        }`;
      }
    },
    loadData() {
      this.list_months = Tools.getMonths();
      this.generateListYears();
      let month_name = this.getMonthName(this.filters.month_value);
      this.handleChangeTitle();
      this.getTotalSales();
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style scoped></style>
